import { GA_MEASUREMENT_ID } from '@/config/analytics';

/**
 * Loads GA4 once, after the app has mounted. Consent Mode v2 defaults are set
 * in index.html before this runs, so measurement starts cookieless and is
 * upgraded by `updateAnalyticsConsent` when the visitor accepts.
 */
let loaded = false;

type GtagFn = (...args: unknown[]) => void;

const gtag = (...args: unknown[]) => {
  const w = window as Window & { gtag?: GtagFn; dataLayer?: unknown[] };
  if (typeof w.gtag === 'function') {
    w.gtag(...args);
    return;
  }
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(args);
};

export const isAnalyticsConfigured = () => GA_MEASUREMENT_ID.length > 0;

export const loadAnalytics = () => {
  if (loaded || !isAnalyticsConfigured() || typeof document === 'undefined') return;
  loaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
};

/** Manual page_view — the app is a SPA, so route changes are sent by hand. */
export const trackPageView = (path: string, title?: string) => {
  if (!isAnalyticsConfigured()) return;
  gtag('event', 'page_view', {
    page_path: path,
    page_location: typeof window !== 'undefined' ? window.location.href : undefined,
    page_title: title,
  });
};

export const updateAnalyticsConsent = (state: 'granted' | 'denied') => {
  gtag('consent', 'update', { analytics_storage: state });
};

export const gtagEvent = (name: string, params: Record<string, unknown>) => {
  if (!isAnalyticsConfigured()) return;
  gtag('event', name, params);
};
